export default __webpack_public_path__ + "static/media/chioma.714e566b.png";